module.exports = __webpack_public_path__ + "img/loudspeaker.d75493f8.png";